import React from 'react'
import styled from 'styled-components';
import i18n from '../i18n';
import {
  CardBodyHead,
  CardBodyFoot,
  CardTitle,
  CardBody,
  Card,
  BoldTitle,
  Icon
} from '../styled/Card';

import ClientIconPath from '../icons/client.svg';
import IncomeIconPath from '../icons/income.svg';
import HoursIconPath from '../icons/time.svg';
import SpendsIconPath from '../icons/spends.svg';
import LineChart from './LineChart';

const placeData = (data, name) => {
  let count;
  let goal;

  const {
    clients_goal_month,
    clients_count_month,
    income_goal_month,
    real_income_month,
    working_hours_count_month,
    working_hours_goal_month,
    monthly_spends_on_therapy
  } = data;

  switch (name) {
    case 'clientsGoal':
      count = clients_count_month || 0;
      goal = clients_goal_month || clients_count_month;
      break;
    case 'incomeGoal':
      count = real_income_month || 0;
      goal = income_goal_month || real_income_month;
      break;
    case 'workingHours':
      count = working_hours_count_month || 0;
      goal = working_hours_goal_month || working_hours_count_month;
      break;
    case 'currentSpends':
      count = monthly_spends_on_therapy || 0;
      goal = real_income_month || monthly_spends_on_therapy;
      break;
  }

  return {
    count,
    goal,
    left: +goal - +count,
    percentFilled: ((count / goal) * 100).toFixed(2),
  }
};

const getImagePath = (name) => {
  const iconsMap = {
    clientsGoal: ClientIconPath,
    incomeGoal: IncomeIconPath,
    workingHours: HoursIconPath,
    currentSpends: SpendsIconPath
  }

  return iconsMap[name];
}

const GoalInfo = styled.div`
  font-size: 15px;
  line-height: 18px;
  font-weight: 500;
  color: #272C2F;
  margin-bottom: 5px;
  > span {
    color: #00B97F;
  }
`;

const Goal = ({ name, data }) => {
  const { count, goal, percentFilled } = placeData(data, name);

  return (
    <Card>
      <CardTitle>{i18n.t(name + '.title')}</CardTitle>
      <CardBody>
        <CardBodyHead>
          <BoldTitle>
            {percentFilled}%
          </BoldTitle>
          <Icon>
            <img src={getImagePath(name)} alt="client-icon" />
          </Icon>
        </CardBodyHead>
        <CardBodyFoot>
          <GoalInfo>
            {count} /
            <span>&nbsp;{goal}</span>
          </GoalInfo>
          <LineChart percent={percentFilled} />
        </CardBodyFoot>
      </CardBody>
    </Card>
  )
};

export default Goal;
